import { Code, Text } from '@chakra-ui/react'
import { createFileRoute } from '@tanstack/react-router'

import { UnsExplorer } from '@/components/UnsExplorer'
import { resolveCentralBroker } from '~/lib/mqttConfig'
import { PACKAGING_PREFIX, PACKAGING_RAW_PREFIX } from '~/lib/packagingLine'

export const Route = createFileRoute('/_app/factory/explorer')({
  component: FactoryExplorerPage,
})

/**
 * Subscribes to the BBCorp tree plus both packaging branches, so the raw feed and
 * the branch the platform consumes can be browsed side by side. That comparison is
 * the cheapest way to show what contextualization actually changes.
 */
const TOPIC_FILTERS = ['BBCorp/#', `${PACKAGING_RAW_PREFIX}/#`, `${PACKAGING_PREFIX}/#`]

function FactoryExplorerPage() {
  // Resolved rather than host-only, so `.env.local` can point this at the local
  // broker instead of the production one during development.
  const broker = resolveCentralBroker()

  return (
    <UnsExplorer
      wsAddress={import.meta.env.VITE_CENTRAL_WS_ADDRESS}
      wsUrl={broker.url}
      username={broker.username ?? ''}
      password={broker.password ?? ''}
      rootName="Namespace"
      topicFilters={TOPIC_FILTERS}
      clientIdPrefix="stories_uns_factory"
      withLevelIcons
      intro={
        <>
          <Text>
            A Unified Namespace (UNS) in Industry 4.0 is typically structured as a hierarchical
            topic taxonomy that mirrors the ISA-95 automation pyramid, organizing data from the shop
            floor to the enterprise level.
          </Text>
          <Text>
            In an MQTT-based UNS, this translates to topic paths like{' '}
            <Code>enterprise/site/area/line/workcell/device/datapoint</Code> enabling any system,
            whether ERP, MES, SCADA, or edge device, to publish or subscribe to exactly the data it
            needs without point-to-point integrations.
          </Text>
        </>
      }
    />
  )
}
